import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Volume = createReactComponent("Volume", ["svg", defaultAttributes, [["polygon", {
  points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5",
  key: "m3abqr"
}]]]);
export default Volume;